import React, { useState, useEffect, lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate, useLocation } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
import { useSelector } from 'react-redux'
import { RootState } from '../redux/store'

const PrivateRoutes = () => {

  //dynamically imports a component and only loads it when it is needed AKA code-splitting
  const DashboardPage = lazy(() => import('../pages/DashboardPage'))

  // My folder
  const AnalyticPage = lazy(() => import('../pages/AnalyticPage'))
  const PaymentVoucherPage = lazy(() => import('../pages/PaymentVoucherPage'))
  const UserProfilePage = lazy(() => import('../pages/UserProfilePage'))
  const CP58ListingPage = lazy(() => import('../pages/CP58ListingPage'))

  // Memo
  const MemoPage = lazy(() => import('../pages/MemoPage'))

  //Company Letter
  const CompanyLetterPage = lazy(() => import('../pages/CompanyLetterPage'))

  //Employee Application
  const EmploymentApplicationPage = lazy(() => import('../pages/EmploymentApplicationPage'))
  const EmploymentApplicationForm = lazy(() => import('../forms/EmploymentApplicationForm'))
  const EmploymentAttachmentPage = lazy(() => import('../pages/EmploymentAttachmentPage'))
  const EmploymentAttachmentForm = lazy(() => import('../forms/EmploymentAttachmentForm'))

  //Purchase 
  const SecurePurchasePage = lazy(() => import('../pages/SecurePurchasePage'))
  const SecurePurchaseForm = lazy(() => import('../forms/SecurePurchaseForm'))
  const PurchaseCumReceiptPage = lazy(() => import('../pages/PurchaseCumReceiptPage'))
  //Rent
  const SecureRentPage = lazy(() => import('../pages/SecureRentPage'))
  const SecureRentForm = lazy(() => import('../forms/SecureRentForm'))

  //My Store
  const StoreOrderListingPage = lazy(() => import('../pages/StoreOrderListingPage'))

  //Developer Sale 
  const DeveloperSalePage = lazy(() => import('../pages/DeveloperSalePage'))
  const DeveloperSaleForm = lazy(() => import('../forms/DeveloperSaleForm'))
  const DeveloperAttachmentForm = lazy(() => import('../forms/DeveloperAttachmentForm'))

  //Claim Submissionn
  const ClaimSubmisionPage = lazy(() => import('../pages/ClaimSubmisionPage'))
  const ClaimSubmisionForm = lazy(() => import('../forms/ClaimSubmisionForm'))

  //Official Receipt
  const ReceiptRequestListing = lazy(() => import('../pages/ReceiptRequestListingPage'))
  const ReceiptRequestHistory = lazy(() => import('../pages/ReceiptRequestHistoryPage'))
  const ReceiptListing = lazy(() => import('../pages/ReceiptListingPage'))

  //Tax Invoice
  const InvoiceRequestListing = lazy(() => import('../pages/InvoiceRequestListingPage'))
  const InvoiceRequestHistory = lazy(() => import('../pages/InvoiceRequestHistoryPage'))
  const InvoiceListing = lazy(() => import('../pages/InvoiceListingPage'))

  const ChangePasswordPage = lazy(() => import('../pages/ChangePasswordPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* default redirect or fallback if route doesnot match */}
        <Route path='*' element={<Navigate to={'/dashboard'} />} />

        <Route
          path='/dashboard'
          element={
            <SuspensedView>
              <DashboardPage />
            </SuspensedView>
          }
        />

        {/* //My folder */}
        <Route
          path='/my-folder/analytic'
          element={
            <SuspensedView>
              < AnalyticPage />
            </SuspensedView>
          }
        />
        <Route
          path='/my-folder/payment-voucher'
          element={
            <SuspensedView>
              < PaymentVoucherPage />
            </SuspensedView>
          }
        />
        <Route
          path='/my-folder/profile'
          element={
            <SuspensedView>
              < UserProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='/my-folder/cp58-listing'
          element={
            <SuspensedView>
              < CP58ListingPage />
            </SuspensedView>
          }
        />

        {/* Memo */}
        <Route
          path='/memo'
          element={
            <SuspensedView>
              < MemoPage />
            </SuspensedView>
          }
        />

        {/* Company Letter */}
        <Route
          path='/company-letter'
          element={
            <SuspensedView>
              < CompanyLetterPage />
            </SuspensedView>
          }
        />

        {/* Employment Application */}
        <Route
          path='/employment-application/employment-listing'
          element={
            <SuspensedView>
              < EmploymentApplicationPage />
            </SuspensedView>
          }
        />
        <Route
          path='/employment-application/attachment-listing'
          element={
            <SuspensedView>
              < EmploymentAttachmentPage />
            </SuspensedView>
          }
        />
        <Route
          path='/employment-application/upload/attachment'
          element={
            <SuspensedView>
              < EmploymentAttachmentForm />
            </SuspensedView>
          }
        />
        <Route
          path='/employment-application/form/:mode'
          element={
            <SuspensedView>
              < EmploymentApplicationForm />
            </SuspensedView>
          }
        />

        {/* Purchase Form */}
        <Route
          path='/purchase-form/secure-purchase-form'
          element={
            <SuspensedView>
              < SecurePurchasePage />
            </SuspensedView>
          }
        />
        <Route
          path='/purchase-form/secure-purchase-form/:mode'
          element={
            <SuspensedView>
              < SecurePurchaseForm />
            </SuspensedView>
          }
        />
        <Route
          path='/purchase-form/purchase-cum-receipt-form'
          element={
            <SuspensedView>
              <PurchaseCumReceiptPage/>
            </SuspensedView>
          }
        />
        <Route
          path='/purchase-form/purchase-cum-receipt-form/:mode'
          element={
            <SuspensedView>

            </SuspensedView>
          }
        />

        {/* Rent Form */}
        <Route
          path='/rent-form/secure-rent-form'
          element={
            <SuspensedView>
              < SecureRentPage />
            </SuspensedView>
          }
        />
        <Route
          path='/rent-form/secure-rent-form/:mode'
          element={
            <SuspensedView>
              < SecureRentForm />
            </SuspensedView>
          }
        />
        <Route
          path='/rent-form/rent-cum-receipt-form'
          element={
            <SuspensedView>

            </SuspensedView>
          }
        />
        <Route
          path='/rent-form/rent-cum-receipt-form/:mode'
          element={
            <SuspensedView>

            </SuspensedView>
          }
        />

        <Route
          path='/my-store/order-listing'
          element={
            <SuspensedView>
              <StoreOrderListingPage />
            </SuspensedView>
          }
        />

        {/* Developer Sale Form */}
        <Route
          path='/developer-sale-form/'
          element={
            <SuspensedView>
              <DeveloperSalePage />
            </SuspensedView>
          }
        />
        <Route
          path='/developer-sale-form/upload/attachment'
          element={
            <SuspensedView>
              <DeveloperAttachmentForm />
            </SuspensedView>
          }
        />
        <Route
          path='/developer-sale-form/:mode'
          element={
            <SuspensedView>
              <DeveloperSaleForm />
            </SuspensedView>
          }
        />

        {/* Sale Submission */}
        <Route
          path='/claim-submission-form'
          element={
            <SuspensedView>
              < ClaimSubmisionPage />
            </SuspensedView>
          }
        />
        <Route
          path='/claim-submission-form/:mode'
          element={
            <SuspensedView>
              < ClaimSubmisionForm />
            </SuspensedView>
          }
        />

        {/* Official Receipt*/}
        <Route
          path='/official-receipt/request-listing'
          element={
            <SuspensedView>
              < ReceiptRequestListing />
            </SuspensedView>
          }
        />
        <Route
          path='/official-receipt/request-history'
          element={
            <SuspensedView>
              < ReceiptRequestHistory />
            </SuspensedView>
          }
        />
        <Route
          path='/official-receipt/listing'
          element={
            <SuspensedView>
              < ReceiptListing />
            </SuspensedView>
          }
        />

        {/* Tax Invoice */}
        <Route
          path='/tax-invoice/request-listing'
          element={
            <SuspensedView>
              < InvoiceRequestListing />
            </SuspensedView>
          }
        />
        <Route
          path='/tax-invoice/request-history'
          element={
            <SuspensedView>
              < InvoiceRequestHistory />
            </SuspensedView>
          }
        />
        <Route
          path='/tax-invoice/listing'
          element={
            <SuspensedView>
              < InvoiceListing />
            </SuspensedView>
          }
        />

        <Route
          path='/settings/change-password'
          element={
            <SuspensedView>
              <ChangePasswordPage />
            </SuspensedView>
          }
        />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const [delayedChildren, setDelayedChildren] = useState<React.ReactNode>(children)
  const location = useLocation()

  useEffect(() => {
    const timer = setTimeout(() => {
      setDelayedChildren(children)
    }, 150) 

    return () => clearTimeout(timer)
  }, [location.pathname, children])

  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })

  return (
    <Suspense fallback={<TopBarProgress />}>
      {delayedChildren}
    </Suspense>
  )
}

export { PrivateRoutes }
